import PropTypes from 'prop-types'
import _ from 'lodash'
import yup from 'yup-legacy'
import createReactClass from 'create-react-class'

import { withGettext } from 'lib/gettext'

import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { Form, Submit } from 'legacy/libs/react-form-tools'
import { isValidUrl } from 'legacy/libs/utils'
import { ProcessErrorsMixin } from 'legacy/libs/mixins'
import messages from 'legacy/common/messages'
import { greaterOrEqualToyearFrom } from 'legacy/common/yupvalidators'
import CollapsibleStepContainer from '../collapsible-step-container'
import Name from './name'
import Description from './description'
import AlternativeNames from './alternative-names'
import YearRangeSelect from './year-range-select'
import EntrySourceSelect from './entry-source-select'
import DataSourceSelect from './data-source-select'
import PollSelect from './poll-select'
import BranchingQuestionsSelect from './branching-questions-select'

const FirstStep = createReactClass({
  mixins: [SchemaBranchMixin, ProcessErrorsMixin],

  propTypes: {
    gettext: PropTypes.func,
    formCursor: BaobabPropTypes.cursor.isRequired,
    stepStateCursor: BaobabPropTypes.cursor.isRequired,
    polls: PropTypes.arrayOf(PropTypes.object),
    secondarySourcesList: PropTypes.arrayOf(PropTypes.object),
    entrySourcesList: PropTypes.arrayOf(PropTypes.object),
    dataSourcesList: PropTypes.arrayOf(PropTypes.object),
    onValidSubmit: PropTypes.func,
    submitText: PropTypes.string,
    editMode: PropTypes.bool,
    onCollapsedChange: PropTypes.func,
  },

  createValidationSchema(gettext, { dataSources }) {
    return function (data) {
      const schema = {
        name: yup
          .string()
          .strict()
          .required(gettext(messages.required))
          .trim(gettext(messages.required)),
        // yup.string().required() works faster than yup.array().required()
        // they work the same way
        description: yup
          .string()
          .strict()
          .required(gettext(messages.required))
          .trim(gettext(messages.required)),
        yearFrom: yup.number().nullable().required(gettext(messages.required)),
        yearFromSign: yup.boolean(),
        yearTo: yup
          .number()
          .nullable()
          .required(gettext(messages.required))
          .test(
            'greaterOrEqualToyearFrom',
            messages.greaterOrEqualToDefaultyearFrom,
            greaterOrEqualToyearFrom
          ),
        yearToSign: yup.boolean(),
        entrySourceExpertPk: yup
          .mixed()
          .test(
            'expertFilledOnExpertSource',
            messages.expertFilledOnExpertSource,
            (value) => {
              if (
                data.entrySource === 'expert' ||
                data.entrySource === 'supervised'
              ) {
                return value !== null
              }

              return true
            }
          ),
        secondarySource: yup
          .mixed()
          .test(
            'secondarySourceFilled',
            messages.secondarySourceFilled,
            (value) => {
              if (data.entrySource === 'secondary') {
                if (value === 0) {
                  return (
                    data.otherSecondarySourceName !== null &&
                    data.otherSecondarySourceName.length > 0
                  )
                }

                return value !== null
              }

              return true
            }
          ),
        otherDataSourceName: yup
          .mixed()
          .test(
            'otherDataSourceNameFilled',
            messages.otherDataSourceNameFilled,
            (value) => {
              if (data.dataSource.pk === 0) {
                return !!value
              }

              return true
            }
          ),
        otherSecondarySourceName: yup
          .mixed()
          .test(
            'otherSecondarySourceNameFilled',
            messages.otherSecondarySourceNameFilled,
            (value) => {
              if (data.secondarySource.pk === 0) {
                return !!value
              }

              return true
            }
          ),
        externalUrl: yup
          .mixed()
          .test('externalUrlFilled', messages.externalUrlFilled, (value) => {
            const chosenDataSource = _.find(dataSources, {
              pk: data.dataSource.pk,
            })

            if (
              data.dataSource.pk === 0 ||
              (chosenDataSource && chosenDataSource.isExternal)
            ) {
              return isValidUrl(value)
            }

            return true
          }),
      }

      if (data.branchingQuestions) {
        if (
          data.branchingQuestions.data &&
          data.branchingQuestions.data.length
        ) {
          schema.branches = yup.string().required(messages.branchesRequired)
        }
      }

      return yup.object().shape(schema)
    }
  },

  cursors() {
    return {
      form: this.props.formCursor,
      stepState: this.props.stepStateCursor,
    }
  },

  onInvalidSubmit(errors) {
    this.cursors.stepState.set('collapsed', false)
    this.processErrors(errors)
  },

  onValidSubmit() {
    this.cursors.form.apply('alternativeNames', (names) =>
      _.reject(names, _.isEmpty)
    )
    if (this.props.onValidSubmit) {
      this.props.onValidSubmit()
    }
  },

  getAvailablePolls() {
    return this.props.polls
  },

  render() {
    const formCursor = this.cursors.form
    const {
      onCollapsedChange,
      entrySourcesList,
      secondarySourcesList,
      dataSourcesList,
      editMode,
      polls,
      submitText,
      gettext,
    } = this.props
    const { stepState } = this.state

    return (
      <div style={{ flex: stepState.collapsed ? 0 : 1 }}>
        <Form
          cursor={formCursor}
          validationSchema={this.createValidationSchema(gettext, {
            dataSources: dataSourcesList,
          })}
          onInvalidSubmit={this.onInvalidSubmit}
          onSubmit={this.onValidSubmit}
          formStateCursor={this.cursors.stepState.select('formState')}
          ref={(ref) => (this.form = ref)}
        >
          <CollapsibleStepContainer
            cursor={this.cursors.stepState.select('collapsed')}
            ref="container"
            title={gettext('Step 1. Enter name and date information')}
            onCollapsedClick={() => stepState.collapsed}
            onCollapsedChange={onCollapsedChange}
          >
            <div className="mx-auto max-w-[980px] space-y-8 px-4 pt-8 pb-16">
              <EntrySourceSelect
                tree={formCursor}
                entrySourcesList={entrySourcesList}
                secondarySourcesList={secondarySourcesList}
              />

              <DataSourceSelect
                tree={formCursor}
                dataSourcesList={dataSourcesList}
              />

              <div className="grid gap-4 sm:grid-cols-2 sm:gap-6 md:gap-8">
                <div className="space-y-4">
                  <Name tree={formCursor} />
                  <AlternativeNames tree={formCursor} />
                </div>

                <div className="space-y-2 text-xs text-default-light sm:pt-6">
                  <p>
                    {gettext(
                      'Think of the name(s) you assign to your group as labels to facilitate searching or browsing, and assign as many as you think useful.'
                    )}
                  </p>

                  <p>
                    {gettext(
                      'In Step 2 you will also be able to add formal tags such as "Buddhism" or "Chinese State Religion".'
                    )}
                  </p>
                </div>
              </div>

              <Description tree={formCursor} />

              {editMode ? null : (
                <>
                  <YearRangeSelect tree={formCursor} />
                  <PollSelect tree={formCursor} polls={polls} />
                  <BranchingQuestionsSelect tree={formCursor} />
                </>
              )}

              <Submit className="btn-submit">
                {submitText || gettext('Save & Continue')}
              </Submit>
            </div>
          </CollapsibleStepContainer>
        </Form>
      </div>
    )
  },
})

export default withGettext(FirstStep)
